import { createComponent } from '@carvana/merch-components';

export const ReviewsSection = createComponent('div', {
  className: 'flex flex-col gap-3xl sm:gap-6xl'
});

export const Container = createComponent('div', {
  className: 'flex flex-col gap-4xl sm:flex-row sm:gap-2xl'
});

export const Card = createComponent('div', {
  className: 'flex flex-col gap-xl sm:w-1/3'
});

export const Rating = createComponent('div', {
  className: 'flex gap-sm'
});

export const Text = createComponent('p', {
  className: 'text-text-default t-body-md sm:t-body-xl'
});

export const Info = createComponent('div', {
  className: 'flex flex-wrap gap-sm'
});

export const User = createComponent('span', {
  className: 'text-text-strong t-strong-lg'
});

export const Location = createComponent('span', {
  className: 'text-text-strong t-body-lg'
});

export const Date = createComponent('span', {
  className: 'text-text-weak t-body-sm'
});
